import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'moment/locale/it';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { Box, useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const localizer = momentLocalizer(moment);

/**
 * @param {boolean} isAdmin
 * @param {date} requestDay
 * @returns Calendar Page UI
 */
export const CalendarUI = ({ isAdmin, hasAuth, requestDay, celebrations, events, onRangeChange, ...props }) => {
  const is600Screen = useMediaQuery('(min-width: 600px)');
  const navigate = useNavigate();

  const [eventsList, setEventsList] = useState([]);

  useEffect(() => {
    setEventsList([...celebrations, ...events]);
  }, [celebrations, events]);

  return (
    <Box sx={{ overflow: 'auto', width: '100%' }} {...props}>
      {/** Generate Calendar Page UI */}
      <Calendar
        messages={{
          next: 'Successivo',
          previous: 'Precedente',
          today: 'Oggi',
          month: 'Mese',
          week: 'Settimana',
          year: 'Anno',
          day: 'Giorno',
          allDay: 'Tutto il giorno',
          agenda: 'Agenda',
          date: 'Data',
          time: 'Ora',
          event: 'Evento',
        }}
        popup
        localizer={localizer}
        events={eventsList}
        startAccessor="start"
        endAccessor="end"
        style={{ height: is600Screen ? '70vh' : '80vh', width: is600Screen ? '100%' : '90vw', margin: '0 auto' }}
        eventPropGetter={(event, start, end, isSelected) => {
          let backgroundColor;
          let borderColor;
          let color = isSelected ? '#fff' : '#333';

          if (event.status === 'draft') {
            backgroundColor = event.type === 'celebration' ? '#d0e7ff' : '#d3f9dfff';
            borderColor = '#999';
          } else if (event.status === 'visible') {
            backgroundColor = event.type === 'celebration' ? '#99ccff' : '#5ef0a7ff';
            borderColor = '#000';
          } else {
            backgroundColor = '#ccc';
            borderColor = '#888';
          }

          if (isSelected) {
            backgroundColor = '#222';
            color = '#fff';
          }

          return {
            style: {
              backgroundColor,
              color,
              border: `1px solid ${borderColor}`,
              borderRadius: '4px',
              padding: '2px 4px',
            },
          };
        }}
        onSelectEvent={(event) => {
          const path = isAdmin ? '/admin/events/handler' : '/user/events/handler';
          navigate(path, { state: { event, redirectType: 'show', isAdmin } });
        }}
        selectable
        onSelectSlot={({ start, end }) =>
          isAdmin &&
          hasAuth &&
          navigate('/admin/events/handler', { state: { start, end, redirectType: 'create', isAdmin } })
        }
        defaultDate={requestDay !== null ? requestDay : null}
        views={['month']}
        onRangeChange={onRangeChange}
      />
    </Box>
  );
};
// Declartion of Calendar UI component parameter types
CalendarUI.propTypes = {
  isAdmin: PropTypes.bool,
  requestDay: PropTypes.object,
  onRangeChange: PropTypes.func,
};
